import {useContext, useState} from "react";
import {CompanyApprovalContext} from "../../tools/contexts/companyApproval/CompanyApprovalContext";
import Button from "../Button";
import BottomButtonWrapper from "../BottomButtonWrapper";
const CompanyCard=({data,index,isSelected,handleSelect})=>{

    return <div onClick={()=>handleSelect(index)} className={`w-full bg-white border-2 p-2  shadow-sm rounded-lg ${isSelected ? 'border-green-500':''}`}>
        <div className="grid gap-2 p-2   grid-cols-2 ">
            <span className="text-sm">نام شرکت</span>
            <span className="text-sm font-semibold">{data.CompanyName}</span>
        </div>
        <div className="grid gap-2 bg-gray-100 p-2    border-b grid-cols-2 ">
            <span className="text-sm">رسته</span>
            <span className="text-sm font-semibold">{data.Field}</span>
        </div>
        <div className="grid  gap-2 p-2    grid-cols-2 ">
            <span className="text-sm">وضعیت</span>
            <span className="text-sm font-semibold">{data.Status.FaType}</span>
        </div>


    </div>
}
const CompanyBusinessInquiry = () => {

    const companyApprovalContext = useContext(CompanyApprovalContext);
    const [currentCompany,setCurrentCompany]=useState(0);
    const handleSelect=(index)=>{
        setCurrentCompany(index)
    }
    const handleConfirm=async () => {
        await companyApprovalContext.handleConfirmCompany(currentCompany);
    }
    return <div className="w-11/12 mx-auto mt-8  lg:w-6/12 xl:w-4/12">
            <h1 className="text-center font-semibold text-xl ">اطلاعات شرکت شما</h1>
            <p className="text-center text-sm mb-3">در صورت تایید ادامه را انتخاب کنید.</p>

            {
            companyApprovalContext.companyList.map((item,index)=>{return <CompanyCard key={index} index={index} handleSelect={handleSelect} isSelected={index===currentCompany} data={item}  />})
            }
        <BottomButtonWrapper>
            <div className="grid grid-cols-1 mt-4 ">
                <Button onClick={handleConfirm} theme="green" rounded="rounded-lg" className="text-sm">تایید و ادامه</Button>
            </div>
        </BottomButtonWrapper>
    </div>
}
export default CompanyBusinessInquiry;